if ($("#shopify-section-cart-template").length > 0) {

// cc related functions and store widget
var storeAddVal = $('#storeAddress').val(),
prevStoreInfo = storeAddVal && typeof storeAddVal === "string" ? JSON.parse(storeAddVal): storeAddVal, // means if this input has value, then it has storedetails which was previously selected
eta = Constant.eta_days_hide_next_day, // for HD - nominated day
blackoutDates = [];

// fluentretail.Store.init({
//         apiKey: Constant.store_widget_api_key,
//         googleAPIKey: Constant.google_map_api_key,
//         initialAddress: Constant.initial_address,
//         targetDiv: "storepickup_container",
//         initialView: "list",
//         storeType: "full",
//         country: {
//               name: "Singapore",
//               code: "sg"
//            },
//         messages: {
//                search: "Search Location",
//                noLocationSelected: "No Location Selected",
//                paginationLeft: "Prev.",
//                paginationRight: "More",
//                loadingError: "We’re so sorry but store pick-up is not working right now!"
//            },
//            extendedCSS:"//cdn.shopify.com/s/files/1/2956/6186/t/243/assets/storewidget.scss.css?v=48577200064090694241630036819"

// });

// parcelpoint.Property.onChange(["storeDetails"], function(key, store){
//   console.log("storeDetails",store);
//   $('#storeAddress').val(JSON.stringify(store));
//   prevStoreInfo = $('#storeAddress').val();
//   displayErrorStore();
// });

function handleCCOption(value) {
//   Shopify.getCart(callForCCApi);
  $('#isStoreSelected').val("true");
//   $('#checkout').prop('disabled', true);  //disable checkout button
  $("#chose-day").prop("checked", false);
  document.getElementById('home-delivery-choice').style.display = 'none';
  showCCOption();
  var radioValue = $("input[name='cc-choice']:checked").val();
  if ((value && value === "raffles") ||
      (!value && prevStoreInfo && prevStoreInfo.storeAddress1 && prevStoreInfo.storeAddress1.indexOf('Raffles') > -1) ||
      (!value && radioValue === "raffles")) {
    $('#storeAddress').val(JSON.stringify(Constant.raffles_store_address));
    $("#raffles-store").prop("checked", true);
  } else { 
    $('#storeAddress').val(JSON.stringify(Constant.heeren_store_address));
    $("#heeren-store").prop("checked", true);
  }
  var storeVal = $('#storeAddress').val();
  prevStoreInfo = storeVal && typeof storeVal === "string" ? JSON.parse(storeVal): storeVal;
  saveCartAttributes("true");

}


 function handleHDOption() {
//    hideStoreList();
   showHdOption();
//    callForHDApiWithCart();

 }


function showStoreList(){
//   if(prevStoreInfo){
  // if there is prev stoe info, then we populate that selected store in cart
//     console.log("storeadd",JSON.parse(prevStoreInfo).storeId);
//     parcelpoint.Store.display({
//       storeExternalId: JSON.parse(prevStoreInfo).storeId
//     });
//   } else {
//     parcelpoint.Store.display({
//     });
//   }

  displayErrorStore();
}


function hideCCOption() {
  console.log("hideCCOption");
  hideStoreList();
  $(".storepickup-tab").hide();

}

function showCCOption() {
  $(".storepickup-tab").show();
  document.getElementById('store-pickup-choice').style.display = 'block';
  if (prevStoreInfo && prevStoreInfo.storeAddress1 && prevStoreInfo.storeAddress1.indexOf('Raffles') > -1) {
  	$("#raffles-store").prop("checked", true);
  } else {
  	$("#heeren-store").prop("checked", true);
  }
  
}

function hideStoreList() {
//     parcelpoint.Store.hide();
    $('#isStoreSelected').val("false");
    $("#raffles-store").prop("checked", false);
    $('#heeren-store').prop('checked', false);
    document.getElementById('store-pickup-choice').style.display = 'none';
    $('#error-store').hide();
}

function displayErrorStore() {
    if (($('#isStoreSelected').val() != "true") || ($('#isStoreSelected').val() == "true" && prevStoreInfo))
    {
    document.getElementById('error-store').style.display = 'none';
    $('#checkout').prop('disabled', false);  //enable checkout button
    }
    else {
          document.getElementById('error-store').style.display = 'block';
    }
  }

// HD  - UI related Functions

function showHdOption() {

  if ($('#isStoreSelected').val() == "true") {
//     document.getElementById('home-delivery-choice').style.display = 'none';
    $("#store-pickup").prop("checked", true);
//     $("#chose-day").prop("checked", false);
    handleCCOption();
//     $('#checkout').prop('disabled', true);  //disable checkout button
   // showStoreList();
  } else { 
    document.getElementById('home-delivery-choice').style.display = 'block';
//     document.getElementById('store-pickup-choice').style.display = 'none';
    $("#home-delivery").prop("checked", true);
//     $('#checkout').prop('disabled', false);  //enable checkout button
    selectDeliveryOption();
    $('#isStoreSelected').val("false");
  }

}

function processDate(date){
   var parts = date.split("/");
   return new Date(parts[2], parts[1] - 1, parts[0]);
}

function convertEtaToDate(eta) {
//   var today = new Date();
//   var dd = today.getDate();
//   var mm = today.getMonth()+1; //January is 0!

//   var yyyy = today.getFullYear();
//   if(dd<10){
//     dd='0'+dd;
//   }
//   if(mm<10){
//     mm='0'+mm;
//   }
//   var today = dd+'/'+mm+'/'+yyyy;
  var today = new Date();
  var numberOfDaysToAdd = eta ? parseInt(eta.substring(0,1), 10) : 0;
  today.setDate(today.getDate() + numberOfDaysToAdd);
  var dd = today.getDate();
  var mm = today.getMonth() + 1;
  var y = today.getFullYear();

  return (dd + '/'+ mm + '/'+ y);
}

function selectDeliveryOption () {
    if ($('#deliveryOptionSelected').val() == Constant.next_day_option) {
      $("#next-day").prop("checked", true);
    } else {
      $("#chose-day").prop("checked", true);
      if (processDate($("#deliveryDate").val()) < processDate(convertEtaToDate(eta))) {
        $("#deliveryDate").val("");
      }
      $("#date").val($("#deliveryDate").val());
    }
    hideShowDatePicker();
}

function hideShowDatePicker() {
   	 if (document.getElementById('chose-day').checked) {
        document.getElementById('pick-date').style.display = 'block';
        $('#deliveryOptionSelected').val(Constant.nominated_day_option);
    }
    else {
      	document.getElementById('pick-date').style.display = 'none';
        $('#deliveryOptionSelected').val(Constant.next_day_option);
    }
  saveCartAttributes("false", $('#deliveryOptionSelected').val());
}




showHdOption();
// $('#checkout').prop('disabled', true);  //disable checkout button  


// Calling Fluent API

// var authApi = function () {
//   return $.ajax({
//     method: 'POST',
//     type: 'POST',
//     url: Constant.fluent_api_url + "/oauth/token?username=" + Constant.fluent_api_username + "&password=" + Constant.fluent_api_password + "&scope=api&client_id=" + Constant.fluent_api_client_id + "&client_secret=" + Constant.fluent_api_client_secret + "&grant_type=password",
//     dataType: 'json',
//     async: true,
//     cache: false,
//     success: function (data) {
//       console.log("AUTHAPI",data);
//       return data;
//     },
//     error: function(err) {
//       console.log(err)
//       return false;
//     }
//   });
// };

// var getHeader = function(accessToken) {
//   var header = {
//     "Content-Type" : "application/json",
//     "Authorization": "bearer "+ accessToken
//   }
//   return header;
// }
// var getRequestPayload = function(cart, orderType, isInventoryCheck, lineID, quantity) {
//   var skusArray = [];
//   var payload  = {
//     limit: 10,
//     orderType: orderType,
//     "trackingId":"track",
//     items: [
//     ],
//     attributes: [],
//     retailerId: Constant.retailer_id
//   };

//   //console.log("inside payload",cart.attributes.isStoreSelected);

//     $.each(cart.items, function (index, item) {
//       var existingSKUPosition = skusArray.indexOf(item.sku);
//       if (existingSKUPosition != -1) {
//         payload.items[existingSKUPosition].requestedQuantity += item.quantity;
//       } else {
//         skusArray.push(item.sku);
//         var cartItem = {};
//         cartItem.skuRef = item.sku;
//         cartItem.requestedQuantity = item.quantity;
//         if(isInventoryCheck && (index == lineID - 1)) {
//           cartItem.requestedQuantity = quantity;
//         }
//         payload.items.push(cartItem);
//       }
//     });

//     return JSON.stringify(payload);
//   }


// // cc API called when qty gets changes with cc selected
// var callForCCApiNew = function (lineID, quantity, parent) {
// console.log("lineID",lineID, "->new quantity",quantity);
// var isInventoryCheck = true;
// Shopify.getCart(function(cart){
//   authApi().done( function( data, textStatus, response ) {
//     console.log("cart from cc radio button", cart);
//     if(textStatus == "success") {
//       return $.ajax({
//         method: 'POST',
//         url: Constant.fluent_api_url + '/api/v4.1/fulfilmentOptions',
//         headers: getHeader(data.access_token),
//         dataType: 'json',
//         data:  getRequestPayload(cart, Constant.order_cc, isInventoryCheck, lineID, quantity),
//         async: true,
//         cache: false,
//         success: function (data) {
//           console.log("callForCCApi"+data);
//           var newQuantity = getAndValidateCCQuantity(data, cart, lineID, quantity, parent, Constant.order_cc);
//           if (!parent.is('#cart_form')) {
//             getAndValidateCCQuantity(data, cart, lineID, quantity, parent, Constant.order_cc);
//           }
//           ajaxSubmitCartItem(newQuantity, lineID, quantity, $('#cart_form'));
//           return data;
//         },
//         error: function(err) {
//           console.log(err);
//           return false;
//         }
//       });

//     } else {
//       console.log("auth was unsuccessful");
//     }

//   })
//   .fail(function (err) {
//     console.error(err);
//   });
// });

// };


//  // cc API called when cart gets changes with cc selected
// var callForCCApi = function (cart, cartTextStatus, xhr) {
//   authApi().done( function( data, textStatus, response ) {
//     console.log("cart from cc radio button", cart);
//      console.log("call for cc - value of storeselected",  $('#isStoreSelected').val());

//     if(textStatus == "success") {
//       return $.ajax({
//         method: 'POST',
//         url: Constant.fluent_api_url + '/api/v4.1/fulfilmentOptions',
//         headers: getHeader(data.access_token),
//         dataType: 'json',
//         data:  getRequestPayload(cart, Constant.order_cc),
//         async: true,
//         cache: false,
//         success: function (data) {
//           console.log("callForCCApi"+data);
//           checkForIneligibleCCAndHD(data, Constant.order_cc, cart);
//           return data;
//         },
//         error: function(err) {
//           console.log(err);
//           return false;
//         }
//       });

//     } else {
//       console.log("auth was unsuccessful");
//     }

//   })
//   .fail(function (err) {
//     console.error(err);
//   });

// };

// // Real time inventory check for HD - Logic Starts
// var callForHDApi = function (lineID, quantity, parent) {
// console.log("lineID",lineID, "->new quantity",quantity);
// var isInventoryCheck = true;

// Shopify.getCart(function(cart){
//   //refreshCart(cart);
//   authApi().done( function( data, textStatus, response ) {
//     console.log("cart from cc radio button", cart);
//     var accessToken = data.access_token;
//     if(textStatus == "success") {
//       return $.ajax({
//         method: 'POST',
//         url: Constant.fluent_api_url + '/api/v4.1/fulfilmentOptions',
//         headers: getHeader(accessToken),
//         dataType: 'json',
//         data:  getRequestPayload(cart, Constant.order_hd, isInventoryCheck, lineID, quantity),
//         async: true,
//         cache: false,
//         success: function (data) {
//           console.log("callForHDApi"+data);
//           var newQuantity = checkHDQuantity(data, cart, lineID, quantity, parent, Constant.order_hd);
//           if (!parent.is('#cart_form')) {
//             checkHDQuantity(data, cart, lineID, quantity, $('#cart_form'), Constant.order_hd);
//           }
//           callBlackoutDatesApi(accessToken);
//           ajaxSubmitCartItem(newQuantity, lineID, quantity, $('#cart_form'));
//           return data;
//         },
//         error: function(err) {
//           console.log(err);
//           return false;
//         }
//       });

//     } else {
//       console.log("auth was unsuccessful");
//       return false;
//     }

//   });
// });

// };

  function ajaxSubmitCartItem(quantity, lineID, oldQty, parent) {
  //here qty is the avail qty coming from api.
  // old qty is the qty user selected
  console.log("quantity",quantity, "---old qty",oldQty);

//     if(oldQty <= quantity) {
        $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: { quantity: quantity, line: lineID },
            success: function (response) {
              Shopify.getCart(refreshCart,response);
              $("#cart_form").attr("action", "/cart").submit();
            }
        });

//     }
//     if(parent.is('#cart_form')) {
//       $("#cart_form").attr("action", "/cart").submit();
//     }


  }

    function ajaxSubmitCart(data) {
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: data,
      success: function (response) {
      console.log("response", JSON.stringify(response));
        Shopify.getCart(refreshCart,response);
        if (data && data.updates && data.updates.includes(0)) {
          $("#cart_form").attr("action", "/cart").submit();
        }
      }
    });
  }

// (function () {
//   if ($('#isStoreSelected').val() == "true") {
//     //CC real time inventory check API on cart page load
// //     Shopify.getCart(callForCCApi);
//   } else {
//   //HD real time inventory check API On cart page load

// //   console.log("HD real time inventory check API On cart page load");
// //   callForHDApiWithCart();

//   }
// })();

//   function callForHDApiWithCart() {

//    Shopify.getCart(function(cart){
//     //refreshCart(cart);
//     authApi().done( function( data, textStatus, response ) {
//       console.log("cart from cc radio button", cart);
//       var accessToken = data.access_token;
//       if(textStatus == "success") {
//         return $.ajax({
//           method: 'POST',
//           url: Constant.fluent_api_url + '/api/v4.1/fulfilmentOptions',
//           headers: getHeader(accessToken),
//           dataType: 'json',
//           data:  getRequestPayload(cart, Constant.order_hd),
//           async: true,
//           cache: false,
//           success: function (data) {
//             console.log("callForHDApi"+data);
//             var parent = $('#cart_form');
//             var newQuantities = [];
//             if (cart && cart.items && cart.items.length) {
//               cart.items.forEach(function (item, index) {
//                 var newQuantity = checkHDQuantity(data, cart, index+1, item.quantity, $('#cart_form'), Constant.order_hd);
//                 newQuantities.push(newQuantity);
//               })
//             }
//             callBlackoutDatesApi(accessToken);
//             ajaxSubmitCart({updates: newQuantities});
//             showHdOption();
//             return data;
//           },
//           error: function(err) {
//             console.log(err);
//             return false;
//           }
//         });

//       } else {
//         console.log("auth was unsuccessful");
//         return false;
//       }

//     });
//   });

//  }

//   function getSkuRealTimeQuantity(data, sku) {
//     var plans = data && data.plans;
//     var fulfilment = plans[0] && plans[0].fulfilments && plans[0].fulfilments[0];
//     var totalQuantity = 0;
//     if(fulfilment && fulfilment.items && fulfilment.items.length) {
//       fulfilment.items.forEach(function (item) {
//         if (item.skuRef === sku) {
//           totalQuantity = totalQuantity + item.availableQty;
//         }
//       });
//       // calling eta handle.
//       if ($('#isStoreSelected').val() == "false") {
//         storeEta(fulfilment);

//       }

//     }
//     return totalQuantity;
//   }

//   function storeEta(fulfilment) {

//   // adding eta from fluent HD response to the global var eta.
//   eta = fulfilment.eta;
//   console.log("fulfilment.eta",fulfilment.eta);
//   //handleNextDayHiding();


// }

// function callBlackoutDatesApi(accessToken){
//   $.ajax({
//     url: Constant.fluent_api_url + '/api/v4.1/settings/retailer/' + Constant.retailer_id + '/BLACKOUT_DATES',
//     headers: getHeader(accessToken),
//     method: 'GET',
//     cache: false,
//     success: function (response) {
//     console.log("blackoutDates", JSON.stringify(response));
//       //Shopify.getCart(refreshCart,response);
//       var blackout_dates_obj = (response.settings && response.settings.length > 0 )? response.settings[0].value : null;
//       blackoutDates = blackout_dates_obj ? blackout_dates_obj.split(",") : null;
//       //handleNextDayHiding();
//       $("#date").prop("disabled", false);
//     }
//   });
// }

// function handleNextDayHiding(){
//   var isNextDayEligible = true;
//   if (parseInt(Constant.eta_days_hide_next_day.substring(0,1),10) < parseInt(eta.substring(0,1),10)) {
//     isNextDayEligible = false;
//   } else {
//     var date = new Date();
//     date.setDate(date.getDate() + parseInt(Constant.eta_days_hide_next_day.substring(0,1),10));
//     //Constant.eta_days_hide_next_day is 1 day.

//     isNextDayEligible  = isDatePresent(date);
//     console.log("isNextDayEligible",isNextDayEligible);
//   }

//   if(!isNextDayEligible) {
//     document.getElementById('next-day-choice').style.display = 'none';
//     $('#deliveryOptionSelected').val(Constant.nominated_day_option);
//     $("#chose-day").prop("checked", true);
//     document.getElementById('pick-date').style.display = 'block';
//   }
// }

//   function checkHDQuantity(data, cart, lineID, quantity, parent, orderType) {
//     var lineIDIndex = lineID - 1;

//           //check to see if there are correct amount of products in array
//           if (typeof cart.items[lineIDIndex] === "undefined") {
//             var updated_quantity = 0;
//           } else {
//             var updated_quantity = getSkuRealTimeQuantity(data, cart.items[lineIDIndex].sku);
//           }

//           if(quantity > 0 && quantity > updated_quantity) {
//             if (updated_quantity == 1) {
//               items_left_text = "item left";
//             } else {
//               items_left_text = "items left";
//             }

//             //$('.warning--quantity').remove();

//             var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
//             if (parent.is('#cart_form')) {
//               parent.find("input[data-line-id='" + lineID + "']").closest('.cart_content_info').find('.warning--quantity').remove();
//             } else {
//               parent.find("input[data-line-id='" + lineID + "']").closest('.cart_item').find('.warning--quantity').remove();
//             }
//             parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
//             parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);

//           } else {
// //             $('.warning--quantity').remove();
//             if (parent.is('#cart_form')) {
//               parent.find("input[data-line-id='" + lineID + "']").closest('.cart_content_info').find('.warning--quantity').remove();
//             } else {
//               parent.find("input[data-line-id='" + lineID + "']").closest('.cart_item').find('.warning--quantity').remove();
//             }
//             parent.find("input[data-line-id='" + lineID + "']").val(quantity);
//             updated_quantity = quantity;
//           }

//     return updated_quantity;
//   }

//   function getAndValidateCCQuantity(data, cart, lineID, quantity, parent, orderType) {
//     var lineIDIndex = lineID - 1;

//           //check to see if there are correct amount of products in array
//           if (typeof cart.items[lineIDIndex] === "undefined") {
//             var updated_quantity = 0;
//           } else {
//             var updated_quantity = getSkuRealTimeQuantity(data, cart.items[lineIDIndex].sku);
//           }

//           if(quantity > 0 && (quantity > updated_quantity)) {
//             hideCCOption();
//             $('#isStoreSelected').val("false");
//             $('#error-cart').show();
//             showHdOption();
//             parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
//           } else {
//             updated_quantity = quantity;
//             parent.find("input[data-line-id='" + lineID + "']").val(quantity);
//             showStoreList();
//           }

//     return updated_quantity;
//   }


// // Real time inventory check for HD - Logic Ends

// function checkForIneligibleCCAndHD(data, orderType, cart) {
//     //if(data && $.isArray(data.items)) {
//         var isInEligible = $.grep(cart.items, function(item, index){
//           //TODO confirm from Bivek this condition (item.availableQuantity < item.requestedQuantity
//           var totalAvailableQty = getSkuRealTimeQuantity(data, item.sku)
//           return (totalAvailableQty < item.quantity);
//         });

//         console.log("isInEligible",isInEligible);
//         if(isInEligible.length > 0 && orderType === Constant.order_cc) {
//           hideCCOption();
//           $('#isStoreSelected').val("false");
//           $('#error-cart').show();
//           showHdOption();
//           $('#home-delivery').trigger('change');
//         } else if(isInEligible.length === 0 && orderType === Constant.order_cc && $('#isStoreSelected').val() == "true") {
//             showStoreList();
//         }
//   //}

// }

  function refreshCart(cart) {
    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var cart_page_savings_html = "";
    var $cart = $(".cart_content form");
    var discounted_price_total = 0;
    var total_savings = 0;

    $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.js-cart_content__form').addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $('.js-cart_content__form').removeClass('hidden');

      $.each(cart.items, function(index, item) {
        var line_id = index + 1;
        cart_items_html += '<li class="cart_item clearfix">';

        // item image
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
              '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
            '</div>';
        }

        // item title
        cart_items_html += '<div class="info-container">'
        cart_items_html +=  '<a href="' + item.url +'">';
        cart_items_html += '<div class="item_title">' + item.title;
        if(item.properties) {
          $.each(item.properties, function(title, value) {
            if (value) {
              cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
            }
          });
        }
        cart_items_html += '</div></a>';

            // item price and qty
        cart_items_html += 
            '<div class="price-container">'
        cart_items_html += 
            '<div class="left product-quantity-box">' +
            '<span class="ss-icon product-minus js-change-quantity" data-func="minus" data-mrt="mc-delete"><span class="icon-minus"></span></span>' +
            '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
            '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
            '</div>';
       
        cart_items_html += 
            '<strong class="right price">'; 

          $.ajax({
            dataType: "json",
            async: false,
            cache: false,
            url: "/products/" + item.handle + ".js",
            success: function(data) {
              var variant_id = item.variant_id;
              var variant = $.grep(data.variants, function(v) {
                return v.id == variant_id;
              });
              var cartVariant = $.grep(cart.items, function(v) {
                return v.id == variant_id;
              });
              if(variant[0] && cartVariant[0].discounted_price < item.price && item.total_discount > 0) {
                cart_items_html += ' <span class="was_price"><span class="money">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</span></span> ';
                if(item.price >= cartVariant[0].discounted_price) {
                    discounted_price_total += cartVariant[0].discounted_price * item.quantity;
                } else {
                    discounted_price_total += item.price * item.quantity;
                }
                total_savings += variant[0].compare_at_price * item.quantity;
              }

              if(cartVariant[0] && cartVariant[0].discounted_price < cartVariant[0].price){
                cart_items_html += '<span class="sale"><span class="money">' + Shopify.formatMoney(cartVariant[0].discounted_price, $cart.data('money-format')) + '</span></span></strong>';
              } else if(variant[0] && item.price < variant[0].compare_at_price){
                cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</span></strong>';
              } else {
                cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</span></strong>';
              }

            }
          });

        cart_items_html += 
            '</div></div></li>'




      });

      cart_action_html += '<span class="right"><span class="money" data-mrt="cart-totalPrice">' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '</span></span>' +
          '<span>Subtotal</span>';

      if(total_savings > 0 ) {
        cart_savings_html = '<span class="right"><span class="money">' + '-' + Shopify.formatMoney(Math.abs(total_savings - discounted_price_total), $cart.data('money-format')) + '</span></span>' +
            '<span>Total Savings</span>';
      } else {
        cart_savings_html = "";
      }

      const $comparedPrice = $('#shopify-section-cart-template').find('[data-compare-price]');
      let itemSavings = 0;
      let totalSaving = 0;

      $comparedPrice.map((i)=>{
        const conparePrice = $($comparedPrice[i]).attr('data-compare-price');
        const price =  $($comparedPrice[i]).attr('data-price');
        const id = $($comparedPrice[i]).attr('data-id');
        const qty = $(`.product-quantity-box input[data-id="${id}"]`).val();
        itemSavings += ( conparePrice - price ) * Number(qty);
      })

      if(itemSavings > 0) {
        // console.log("totalSaving",totalSaving)
        // console.log("itemSavings",itemSavings)
        // console.log(" cart.total_price", cart.total_price)
        const discount = cart.total_discount;
        totalSaving = (itemSavings + discount);

        cart_page_savings_html = `
          <span class="right">
            <span class="money">
              ${ Shopify.formatMoney(totalSaving, $cart.data('money-format')) }
            </span>
          </span>
          <span>
             Total Savings
          </span>`
      }
      
    }

    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);
    $('.js-cart-page-saving').html(cart_page_savings_html).show();

    

    /* code added to highlight the cart if items are present both in desktop and mobile */
    if (cart.item_count > 0) {

      if($('#header').is(':visible')) {
        $('.sticky-footer .cart_container').addClass('highlight_cart');
      } else {
        $('.top_bar .cart_container').addClass('highlight_cart');
      }

    } else {
      if($('#header').is(':visible')) {
        $('.sticky-footer .cart_container').removeClass('highlight_cart');
      } else {
        $('.top_bar .cart_container').removeClass('highlight_cart');
      }
    }
  }

//   $('body').on("change", "#cart_form input.quantity", function() {
//   if ($('#isStoreSelected').val() == "true") {
//     //CC real time inventory check API on cart page load
//     callForCCApiNew($(this).data('line-id'), Number($(this).val()), $(this).parents('#cart_form'));
//   } else {
//     callForHDApi($(this).data('line-id'), Number($(this).val()), $(this).parents('#cart_form'));
//     console.log("new qty",$(this).val());
//   }
//   });

//   $('body').on("change", ".cart_content input.quantity", function() {
//     if ($('#isStoreSelected').val() == "true") {
//     //CC real time inventory check API on cart page load
//     callForCCApiNew($(this).data('line-id'), Number($(this).val()), $(this).parents('.cart_content'));
//   } else {
//     callForHDApi($(this).data('line-id'), Number($(this).val()), $(this).parents('.cart_content'));
//     console.log("new qty", Number($(this).val()));
//   }
//   });


  function isDatePresent(date, isDatePicker) {
    var dateFormat = jQuery.datepicker.formatDate('dd-mm-yy', date);
    if(isDatePicker){
      return [$.inArray(dateFormat, blackoutDates) == -1];
    }
    else {
      return $.inArray(dateFormat, blackoutDates) == -1;
    }
  }
  
  $("body").on("click", "#date", function(){
      $("#date").datepicker("destroy");
//       console.log("eta",eta);
//       var startDate = eta === "1D" ? "2D" : eta,
//       maxDate = "+"+Constant.max_num_of_days + "+"+startDate; // we need to minus 1 day as we are adding the startdate
      var startDate;
      var maxDate;
      var today = new Date();
      var cutOffDate = new Date();
      cutOffDate.setHours(16);
      cutOffDate.setMinutes(0);
      cutOffDate.setSeconds(0);
      if ($("#isDSVItem").val() === "true") {
//         startDate = (eta === "1D" || eta === "2D" ? "3D" : eta);
        startDate = "6D";
      } else {
//         startDate = today < cutOffDate ? "0D" : (eta === "1D" ? "2D" : eta); 
//         startDate = (eta === "1D" || eta === "2D" ? "3D" : eta); 
        startDate = "6D";
      }

//       var startDate = today < cutOffDate ? "0D" : (eta === "1D" ? "2D" : eta);
      maxDate = "+"+Constant.max_num_of_days + "+"+startDate; // we need to minus 1 day as we are adding the startdate


      $("#date").datepicker( {
        minDate: startDate,
        maxDate: maxDate ,
        showOtherMonths: true,
        selectOtherMonths: true,
        beforeShowDay: function(date){
            var dateFormat = jQuery.datepicker.formatDate('dd-mm-yy', date);
//             Commented code is to hide sunday and blackout dates
//             var day = date.getDay();
//             if (day === 0) {
//               return [false];
//             } else {
//               return [$.inArray(dateFormat, blackoutDates) == -1];
//             }
          return [$.inArray(dateFormat, blackoutDates) == -1];
        },
        onSelect: function(date) {
          $(this).removeClass('error');
          $("#deliveryDate").val(date);
        },
        dateFormat: 'dd/mm/yy'
      });

      $("#date").focus();
    });

  function saveCartAttributes(isStoreSelected, deliveryOptionSelected) {
    var data = {
      attributes: {
        isStoreSelected: isStoreSelected
      }
    };
    if (deliveryOptionSelected) {
      data.attributes.deliveryOptionSelected = deliveryOptionSelected;
    }
      $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: data,
      success: function (response) {
      console.log("response", JSON.stringify(response));
        Shopify.getCart(refreshCart,response);
      }
    });

  }

  //MOON CAKE SCRIPTS STARTS
      
      var dd = 6;
      var threshold = 1000; // GETTING VALUE FROM SCHEMA SETTINGS
      var startdate= "Sep 14, 2020";
      var enddate="Sep 28, 2020";
      var CurrentDate = new Date();
      var releaseDate = new Date(startdate);
      var tdays,returnedDate,disabledSpecificDays;
      var ph = ["08-09-2019", "08-12-2019"]; //PUBLIC HOLIDAYS 2019
//       var tokenString = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnQiOiJyc2giLCJlbnYiOiJzdGFnaW5nIiwidXVpZCI6IjRmODgyYzdlLWE2NGMtNGQzYS1iNjQxLTM2NmE3ZGM4ODFlZSJ9.NBS2CQGdoF0iCQapDGWc5R2Vtk0bWLHMllDunbZU0DM";
//       var mooncake_url_str = "https://rob.ap.ngrok.io/webhook/rob/" + Constant.store_env + "/mooncake/disabled/dates";
 
      function disableSpecificDaysAndWeekends(date) {
        var string = jQuery.datepicker.formatDate('mm-dd-yy', date);
         if (disabledSpecificDays && disabledSpecificDays.indexOf(string) != -1)
                return [false];

        var noWeekend = $.datepicker.noWeekends(date);
        return noWeekend;

      }
  
      function countWeekendDays(date1, date2) {
        var d1 = new Date(date1),
        d2 = new Date(date2), 
        weekendDays = 0,
        isWeekend = false;

        while (d1 <= d2) {
            var day = d1.getDay();
            isWeekend = (day === 6) || (day === 0); 
            if (isWeekend) { weekendDays++; } // return immediately if weekend found
            d1.setDate(d1.getDate() + 1);
        }
        return weekendDays;
      }
 
//   // AJAX TO FETCH DATE BASED ON THRESHOLD
//       $.ajax({
//         url: mooncake_url_str,
//         dataType: 'json',
//         type:'POST',
//         cache: false,
//         async:false,
//         data: {
//           threshold: threshold
//         },
//         success: function(data, status) {
//           $("#date1").prop("disabled", false);
//           disabledSpecificDays = $.merge(ph,data);
//           if(CurrentDate <= releaseDate) 
//             tdays = releaseDate;
//           else
//             tdays = new Date(CurrentDate.setDate(CurrentDate.getDate()+dd));

//           $("#date1").click(function(){
//             $("#date1").datepicker("destroy");
//             $("#date1").datepicker( {
//               minDate: tdays,
//               maxDate: new Date(enddate),
//               showOtherMonths: true,
//               beforeShowDay: disableSpecificDaysAndWeekends,
//               onSelect: function(date) {
//                 $(this).removeClass('error');
//                 $("#deliveryDate").val(date);
//               },
//               dateFormat: 'dd/mm/yy'
//             });
//             $("#date1").focus();
//           });
//         },
//         beforeSend: function(xhr, settings) { xhr.setRequestHeader('Authorization','Bearer ' + tokenString ); } //set tokenString before send
//       }); 
  
  		$("#date1").prop("disabled", false);
//           disabledSpecificDays = $.merge(ph,data);
          tdays = new Date(new Date().setDate(CurrentDate.getDate()+dd));
          noOfWeekendDays = countWeekendDays(CurrentDate, tdays);
          tdays = new Date(tdays.setDate(tdays.getDate()));
          if(tdays <= releaseDate) 
            tdays = releaseDate;
            

          $("#date1").click(function(){
            $("#date1").datepicker("destroy");
            $("#date1").datepicker( {
              minDate: tdays,
              maxDate: new Date(enddate),
              showOtherMonths: true,
//               beforeShowDay: disableSpecificDaysAndWeekends,
              beforeShowDay: function(date) {
                var day = date.getDay();
                return [(day != 0), ''];
              },
              onSelect: function(date) {
                $(this).removeClass('error');
                $("#deliveryDate").val(date);
              },
              dateFormat: 'dd/mm/yy'
            });
            $("#date1").focus();
          });
  
  // MOON CAKE SCRIPTS ENDS 

function isPreviousDate(d1, d2) {
    var diffTime = d1.getTime() - d2.getTime();
    var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    return diffDays < 0;
  }
  
  // FUNCTION TO VALIDATE IF DELIVERY DATE IS EMPTY /or Click & Collect store not selected
  $( "#checkout").click(function( event ) {
   if($('#date').length!=0 && $('#chose-day').prop('checked') && $('#isStoreSelected').val() != "true") {
     var f;
     if ($('#date').val()) {
       var from = $('#date').val().split("/");
       f = new Date(from[2], from[1] - 1, from[0])   
     }
    
     if ($('#date').val()==null || $('#date').val()=="") {
       $("#date").addClass("error");
  	   return false;
     } else if (isPreviousDate(f, new Date())) {
       $("#date").datepicker("setDate", null);
       $("#deliveryDate").val($("#date").val());
       $("#date").addClass("error");

       return false;

     }
    $("#date").removeClass("error");
    return true;
   } else if ($('#date1').length!=0 && $('#chose-day').prop('checked') && $('#isStoreSelected').val() != "true") {
    if ($('#date1').val()==null || $('#date1').val()=="") {
       $("#date1").addClass("error");
  	  return false;
   }
    $("#date1").removeClass("error");
    return true;
   }
    else if ($('#isStoreSelected').val() == "true") {
    	return true;
    }
  });
}
  
